export default __webpack_public_path__ + "static/media/producto-21.8f31ba4f.jpeg";